import {doGetRequest, doPostRequest, doPutRequest, doDeleteRequest} from '../../../tools/axios_';
import { Utils } from '../../../tools/utils';
/**
 * 账户信息
 **/
export const getTreeDate  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/get_company_tree',
        params: data
    });
}

// 角色列表
export const getRoleList  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/role_list',
        params: data
    });
}
// 角色结构树
export const getCompanyTree  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/get_company_tree',
        params: data
    });
}

// 角色详情
export const getRoleDetailOrderById  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/role_detail',
        params: data
    });
}
// 获取权限树
export const getFunctionTree  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/function_tree',
        params: data
    });
}
// 新增角色
export const saveRoleInfo = async (data) => {
    return await doPostRequest({
        url: '/api/v2/system/save_role',
        data
    })
}
// 编辑角色
export const saveRoleEdit = async (data) => {
    return await doPostRequest({
        url: '/api/v2/system/save_role_edit',
        data
    })
}
// 角色删除
export const delRoleInfo  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/del_role',
        params: data
    });
}
// 获取指定编码用户数据权限
export const getUserPermissionInfoByCode  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/get_user_permission_info_by_code',
        params: data
    });
}
// 变更角色
export const changeRole = async (data) => {
    return await doPostRequest({
        url: '/api/v2/system/change_role',
        data
    })
}
// 账号列表
// api/admin/merchantPlatform/account/list
export const accountList = async (data) => {
    return await doPostRequest({
        url: '/api/v2/system/account_list',
        data
    })
}
//获取用户功能数据权限
export const getUserPermissionInfo  = async (data) => {
    return await doGetRequest({
        url: '/api/v2/system/get_user_permission_info',
        data
    });
}